<template>
  <div class="empty">
    <img
      class="img"
      src="https://img.xunfei.cn/mall/ifly-mall-web/common/applet_move_version.jpg?q=80&c=1&f=webp"
    />
    <div class="text">
      抱歉，该区域暂未开放门店。欢迎扫码进入讯飞商城，足不出户即可选购心仪产品！
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: "Empty",
};
</script>

<style lang="less" scoped>
.empty {
  width: 305px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .img {
    width: 180px;
    height: 180px;
  }
  .text {
    font-size: 16px;
    color: #969799;
    font-weight: 400;
    line-height: 22px;
    margin-top: 12px;
  }
}
</style>
